/*
  REVIEWS.io translation safety net for brand/product terms.
  Scope: visible text nodes inside REVIEWS.io widgets/modals only.
  Reason: REVIEWS.io auto-translation can mistranslate "Judeswindeln" as variants of "Jewish diapers".
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = [
    '#ReviewsWidget',
    '#reviewsio-carousel-widget',
    '[id^="reviewsio-carousel-widget-"]',
    '[data-reviewsio-widget]',
    '.js-modal-container',
    '.CarouselWidget-prefix'
  ].join(',');

  var SKIP_TAGS = {
    SCRIPT: true,
    STYLE: true,
    NOSCRIPT: true,
    TEXTAREA: true,
    INPUT: true,
    SELECT: true
  };

  var FIXES = [
    // English
    ['Jewish diapers', 'Judes diapers'],
    ['Jewish diaper', 'Judes diaper'],
    ['jewish diapers', 'Judes diapers'],
    ['jewish diaper', 'Judes diaper'],

    // French
    ['couches juives', 'couches Judes'],
    ['couche juive', 'couche Judes'],
    ['Couches juives', 'Couches Judes'],
    ['Couche juive', 'Couche Judes'],

    // Spanish
    ['pañales judíos', 'pañales Judes'],
    ['pañal judío', 'pañal Judes'],
    ['Pañales judíos', 'Pañales Judes'],
    ['Pañal judío', 'Pañal Judes'],

    // Italian
    ['pannolini ebraici', 'pannolini Judes'],
    ['pannolino ebraico', 'pannolino Judes'],
    ['Pannolini ebraici', 'Pannolini Judes'],
    ['Pannolino ebraico', 'Pannolino Judes'],

    // Dutch
    ['Joodse luiers', 'Judes luiers'],
    ['Joodse luier', 'Judes luier'],
    ['joodse luiers', 'Judes luiers'],
    ['joodse luier', 'Judes luier'],

    // Danish
    ['jødiske bleer', 'Judes bleer'],
    ['jødisk ble', 'Judes ble'],
    ['Jødiske bleer', 'Judes bleer'],
    ['Jødisk ble', 'Judes ble'],

    // Swedish
    ['judiska blöjorna', 'Judes-blöjorna'],
    ['judiska blöjor', 'Judes-blöjor'],
    ['judisk blöja', 'Judes-blöja'],
    ['Judiska blöjorna', 'Judes-blöjorna'],
    ['Judiska blöjor', 'Judes-blöjor'],
    ['Judisk blöja', 'Judes-blöja'],

    // Portuguese
    ['fraldas judias', 'fraldas Judes'],
    ['fralda judia', 'fralda Judes'],
    ['Fraldas judias', 'Fraldas Judes'],
    ['Fralda judia', 'Fralda Judes'],

    // Bulgarian
    ['Еврейските памперси', 'Памперсите Judes'],
    ['еврейските памперси', 'памперсите Judes'],
    ['Еврейска пелена', 'Пелена Judes'],
    ['еврейска пелена', 'пелена Judes'],

    // Japanese / Korean / Chinese
    ['ユダヤのおむつ', 'Judesのおむつ'],
    ['ユダヤ人のおむつ', 'Judesのおむつ'],
    ['유태인 기저귀', 'Judes 기저귀'],
    ['유대인 기저귀', 'Judes 기저귀'],
    ['犹太人的尿布', 'Judes 尿布'],
    ['猶太人的尿布', 'Judes 尿布']
  ];

  var queuedRoots = [];
  var scheduled = false;

  function replaceAll(text, search, replacement) {
    return text.indexOf(search) === -1 ? text : text.split(search).join(replacement);
  }

  function fixTextNode(node) {
    if (!node || !node.nodeValue) return;
    var parent = node.parentElement;
    if (!parent || SKIP_TAGS[parent.tagName]) return;

    var current = node.nodeValue;
    var next = current;

    for (var i = 0; i < FIXES.length; i += 1) {
      next = replaceAll(next, FIXES[i][0], FIXES[i][1]);
    }

    if (next !== current) {
      node.nodeValue = next;
    }
  }

  function fixRoot(root) {
    if (!root || root.nodeType !== 1) return;

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          var parent = node.parentElement;
          if (!parent || SKIP_TAGS[parent.tagName]) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var node;
    while ((node = walker.nextNode())) {
      fixTextNode(node);
    }
  }

  function queueRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (queuedRoots.indexOf(root) === -1) queuedRoots.push(root);

    if (!scheduled) {
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        var roots = queuedRoots.slice();
        queuedRoots = [];
        for (var i = 0; i < roots.length; i += 1) {
          fixRoot(roots[i]);
        }
      }, 0);
    }
  }

  function rootFromNode(node) {
    if (!node) return null;

    if (node.nodeType === 3) {
      return node.parentElement && node.parentElement.closest(ROOT_SELECTOR);
    }

    if (node.nodeType !== 1) return null;

    if (node.matches(ROOT_SELECTOR)) return node;

    return node.closest(ROOT_SELECTOR) || node.querySelector(ROOT_SELECTOR);
  }

  function runInitialPass() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i += 1) {
      queueRoot(roots[i]);
    }
  }

  function observe() {
    if (!document.body) return;

    runInitialPass();

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];

        if (mutation.type === 'characterData') {
          var textRoot = rootFromNode(mutation.target);
          if (textRoot) queueRoot(textRoot);
          continue;
        }

        var targetRoot = rootFromNode(mutation.target);
        if (targetRoot) queueRoot(targetRoot);

        for (var j = 0; j < mutation.addedNodes.length; j += 1) {
          var addedRoot = rootFromNode(mutation.addedNodes[j]);
          if (addedRoot) queueRoot(addedRoot);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();